import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["className", "icon", "intent", "isActive", "isMultiline", "isFocused", "isDisabled", "margin", "marginBottom", "marginLeft", "marginRight", "marginTop", "marginX", "marginY", "onClick", "padding", "paddingBottom", "paddingLeft", "paddingRight", "paddingTop", "paddingX", "paddingY", "shouldDismissPopover", "tag", "label"],
  _excluded2 = ["className", "icon", "intent", "isActive", "isMultiline", "isFocused", "label", "isDisabled", "margin", "marginBottom", "marginLeft", "marginRight", "marginTop", "marginX", "marginY", "onClick", "padding", "paddingBottom", "paddingLeft", "paddingRight", "paddingTop", "paddingX", "paddingY", "shouldDismissPopover", "tag"];
import * as React from 'react';
import cn from 'classnames';
import { ControlAppearanceType, ControlDensityType, ControlShapeType, ControlSizeType, intentClass, safeInvoke, useSpacingProps } from '../../../library';
import { menuClasses } from './menu';
import { popupClasses } from '../../popup';
import { Tag } from '../../tag';
function getMenuItemClasses(props) {
  return cn(menuClasses.ITEM, intentClass(props.intent), _defineProperty({
    '-active': props.isActive,
    '-focused': props.isFocused,
    '-disabled': props.isDisabled,
    '-multiline': props.isMultiline
  }, popupClasses.DISMISS, props.shouldDismissPopover), props.className);
}
var MenuItemInner = function MenuItemInner(props) {
  var tagProps = typeof props.tag === 'string' ? {
    children: props.tag
  } : props.tag;
  return React.createElement(React.Fragment, null, props.icon !== undefined ? props.icon : null, React.createElement("span", {
    className: menuClasses.TEXT
  }, props.children ? props.children : props.label), props.tag === undefined ? null : React.createElement(Tag, _extends({
    appearance: ControlAppearanceType.FILL,
    shape: ControlShapeType.CIRCULAR,
    size: ControlSizeType.SMALL,
    density: ControlDensityType.COMPACT,
    intent: props.intent
  }, tagProps)));
};
export var MenuItem = React.forwardRef(function (props, ref) {
  var className = props.className,
    icon = props.icon,
    intent = props.intent,
    isActive = props.isActive,
    isMultiline = props.isMultiline,
    isFocused = props.isFocused,
    isDisabled = props.isDisabled,
    margin = props.margin,
    marginBottom = props.marginBottom,
    marginLeft = props.marginLeft,
    marginRight = props.marginRight,
    marginTop = props.marginTop,
    marginX = props.marginX,
    marginY = props.marginY,
    onClick = props.onClick,
    padding = props.padding,
    paddingBottom = props.paddingBottom,
    paddingLeft = props.paddingLeft,
    paddingRight = props.paddingRight,
    paddingTop = props.paddingTop,
    paddingX = props.paddingX,
    paddingY = props.paddingY,
    shouldDismissPopover = props.shouldDismissPopover,
    tag = props.tag,
    label = props.label,
    htmlProps = _objectWithoutProperties(props, _excluded);
  var _useSpacingProps = useSpacingProps({
      margin: margin,
      marginBottom: marginBottom,
      marginLeft: marginLeft,
      marginRight: marginRight,
      marginTop: marginTop,
      marginX: marginX,
      marginY: marginY,
      padding: padding,
      paddingBottom: paddingBottom,
      paddingLeft: paddingLeft,
      paddingRight: paddingRight,
      paddingTop: paddingTop,
      paddingX: paddingX,
      paddingY: paddingY
    }),
    marginClasses = _useSpacingProps.marginClasses,
    paddingClasses = _useSpacingProps.paddingClasses;
  var classNames = cn(getMenuItemClasses(props), marginClasses, paddingClasses);
  var handleClick = function handleClick(e) {
    if (props.isDisabled) {
      e.preventDefault();
    } else {
      safeInvoke(props.onClick, e);
    }
  };
  return React.createElement("div", _extends({
    className: classNames,
    ref: ref,
    onClick: handleClick
  }, htmlProps), MenuItemInner(props));
});
MenuItem.displayName = 'MenuItem';
MenuItem.defaultProps = {
  isActive: false,
  isDisabled: false,
  isFocused: false,
  isMultiline: false,
  shouldDismissPopover: true
};
export var MenuLink = React.forwardRef(function (props, ref) {
  var className = props.className,
    icon = props.icon,
    intent = props.intent,
    isActive = props.isActive,
    isMultiline = props.isMultiline,
    isFocused = props.isFocused,
    label = props.label,
    isDisabled = props.isDisabled,
    margin = props.margin,
    marginBottom = props.marginBottom,
    marginLeft = props.marginLeft,
    marginRight = props.marginRight,
    marginTop = props.marginTop,
    marginX = props.marginX,
    marginY = props.marginY,
    onClick = props.onClick,
    padding = props.padding,
    paddingBottom = props.paddingBottom,
    paddingLeft = props.paddingLeft,
    paddingRight = props.paddingRight,
    paddingTop = props.paddingTop,
    paddingX = props.paddingX,
    paddingY = props.paddingY,
    shouldDismissPopover = props.shouldDismissPopover,
    tag = props.tag,
    htmlProps = _objectWithoutProperties(props, _excluded2);
  var _useSpacingProps2 = useSpacingProps({
      margin: margin,
      marginBottom: marginBottom,
      marginLeft: marginLeft,
      marginRight: marginRight,
      marginTop: marginTop,
      marginX: marginX,
      marginY: marginY,
      padding: padding,
      paddingBottom: paddingBottom,
      paddingLeft: paddingLeft,
      paddingRight: paddingRight,
      paddingTop: paddingTop,
      paddingX: paddingX,
      paddingY: paddingY
    }),
    marginClasses = _useSpacingProps2.marginClasses,
    paddingClasses = _useSpacingProps2.paddingClasses;
  var classNames = cn(getMenuItemClasses(props), marginClasses, paddingClasses);
  var handleClick = function handleClick(e) {
    if (props.isDisabled) {
      e.preventDefault();
    } else {
      safeInvoke(props.onClick, e);
    }
  };
  return React.createElement("a", _extends({
    className: classNames,
    ref: ref
  }, htmlProps, {
    onClick: handleClick
  }), MenuItemInner(props));
});
MenuLink.displayName = 'MenuLink';
MenuLink.defaultProps = {
  isActive: false,
  isDisabled: false,
  isFocused: false,
  isMultiline: false,
  shouldDismissPopover: true
};